import { useCallback } from 'react';
import { useEvent } from 'react-use';

/**
 * AG Grid popups do not always close on outside click—especially when a grid is rendered inside a
 * React Portal (e.g. a Modal). With the modern column menu, the column chooser also needs explicit
 * dismissal via hideColumnChooser. Listen for body mousedown outside `.ag-popup` and close open popups.
 */
export function useAgGridPopupClosing(hidePopupMenu: () => void): void {
  const handleDocumentClick = useCallback(
    (e: Event) => {
      if (e.target instanceof Element) {
        const clickIsWithinAgPopup = e.target.closest('.ag-popup') != null;
        if (!clickIsWithinAgPopup) {
          hidePopupMenu();
        }
      }
    },
    [hidePopupMenu]
  );

  useEvent('mousedown', handleDocumentClick, document);
}
